import { selectToken, selectUser } from "Data/Redux/Slices/User";
import { valueDeepChangedPredicate } from "Data/Redux/Middleware/Predicates";
import type { AnyListenerPredicate } from "@reduxjs/toolkit";
import type { AppState } from "Data/Redux/Reducers";

export const userLoggedInPredicate: AnyListenerPredicate<AppState> = (action, currentState, previousState) => {
	const token = selectToken(currentState);
	const newUser = selectUser(currentState);
	const userChanged = valueDeepChangedPredicate(selectUser)(action, currentState, previousState);

	return userChanged && !!newUser && !!token;
};
